<template>
    <div class="landscape-profile-photo">
        <VJoyAvatar :src="photoUrl" :size="photoSize" :full-name="fullName">
            <MaltImg
                v-if="photoUrl"
                :src="photoUrl"
                :alt="alt"
                :width="width"
                :height="width"
                :quality="90"
                :modifiers="{
                    gravity: 'face',
                    func: 'face',
                    face_margin: 60,
                }"
            />
        </VJoyAvatar>
    </div>
</template>

<script setup lang="ts">
    import {computed} from 'vue';
    import {MaltImg} from '#components';
    import {useDisplayMobile} from '@malt/utils';
    import {VJoyAvatar} from '@maltjoy/core-vue';

    const props = defineProps<{
        photoUrl?: string;
        fullName?: string;
        alt: string;
    }>();

    const {isDisplayMobile} = useDisplayMobile('Xs');

    const photoSize = computed(() => (isDisplayMobile.value ? 'medium' : 'xlarge'));
    const width = computed(() => (isDisplayMobile.value ? 80 : 100));
</script>
